import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-component';

import FotoFlatOffer from '../event/FotoFlatOffer';
import MediaListInfoTile from './MediaListInfoTile';
import { PARTICIPANT } from '../../../utils/variables';

const MediaListMasonry = ({
  children,
  listType,
  onImagesLoaded,
  fotoFlatOffer,
  participantMediaCount,
  onBuyFotoFlatClick,
  impressionMediaCount,
  onScrollToImpressions,
  onScrollToVoucher,
  onScrollToExtendedSearch,
  onScrollToCertificate,
  showMorePhotosBox,
  onScrollToVideo,
  setFotoFlatRef,
  hasVideo,
  hasVideoUrl,
  hasCertificates,
  hasCertificateUrl,
  isMainSearchUsed,
  onScrollToMainSearch,
  goBackToMainSearchResults,
  eventHasFotoFlat,
}) => {
  const [mobile, setMobile] = useState(null);
  const fotoFlatIndex = mobile ? 4 : 3;
  const containerElementRef = useRef();

  useEffect(() => {
    window.addEventListener('resize', getSizes);
    getSizes();

    // componentWillUnmount
    return () => {
      window.removeEventListener('resize', getSizes);
    };
  }, []);

  const getSizes = () => {
    const windowWidth = window.innerWidth;

    //temporary fix for case when resizing happens when component is not yet mounted
    // revisit eventually
    // if (!this.state) {
    //   return;
    // }

    if (windowWidth >= 768) {
      setMobile(false);
    } else {
      setMobile(true);
    }
  };

  const onImagesLoadeFix = (imagesLoaded) => {
    //we manually add classes to html elements to avoid a strange behavior with
    //this library which caused a memory leak when updating state in this method
    imagesLoaded.images.forEach((image) => {
      if (!image.loaded && image.img && image.img.classList) {
        image.loaded = true;
        image.img.classList.add('image-loaded');
      }
    });
    containerElementRef.current?.classList.add('show-fotoflat-offer');

    if (listType === PARTICIPANT && onImagesLoaded) {
      onImagesLoaded();
    }
  };

  return (
    <div className="medialist-container" ref={containerElementRef}>
      <div>
        <Masonry
          className="masonry-container"
          options={{
            columnWidth: '.medialist-item-container',
            gutter: 0,
            itemSelector: '.medialist-item-container',
            percentPosition: true,
          }}
          disableImagesLoaded={false}
          updateOnEachImageLoad={true}
          onImagesLoaded={onImagesLoadeFix}
        >
          {children.slice(0, fotoFlatIndex)}
          {fotoFlatOffer && (
            <FotoFlatOffer
              key="FotoFlatOffer"
              offer={fotoFlatOffer}
              mobile={mobile}
              participantMediaCount={participantMediaCount}
              impressionMediaCount={impressionMediaCount}
              onBuyFotoFlatClick={onBuyFotoFlatClick}
              onScrollToImpressions={onScrollToImpressions}
              onScrollToVoucher={onScrollToVoucher}
              onScrollToCertificate={onScrollToCertificate}
              setFotoFlatRef={setFotoFlatRef}
              hasVideo={hasVideo}
              onScrollToVideo={onScrollToVideo}
              hasVideoUrl={hasVideoUrl}
              hasCertificates={hasCertificates}
              hasCertificateUrl={hasCertificateUrl}
            />
          )}
          {eventHasFotoFlat &&
            (listType === 'categories' ||
              listType === 'dual' ||
              listType === 'gps' ||
              listType === 'suggestions') && (
              <div className="medialist-item-container more-info-tile-container">
                <MediaListInfoTile
                  key="MediaListInfoTile-alternativeSearch"
                  type="alternativeSearchHint"
                  isMainSearchUsed={isMainSearchUsed}
                  onClick={() => {
                    if (isMainSearchUsed) {
                      goBackToMainSearchResults();
                    } else {
                      onScrollToMainSearch && onScrollToMainSearch();
                    }
                  }}
                />
              </div>
            )}
          {children.slice(fotoFlatIndex)}
          {showMorePhotosBox && (
            <div className="more-info-tile-container pricelist-container medialist-item-container">
              <MediaListInfoTile
                key="MediaListInfoTile-searchForMorePhotos"
                type="morePhotos"
                participantMediaCount={participantMediaCount}
                onClick={onScrollToExtendedSearch}
              />
            </div>
          )}
        </Masonry>
      </div>
    </div>
  );
};

MediaListMasonry.propTypes = {
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  fotoFlatOffer: PropTypes.object,
  children: PropTypes.node,
  onBuyFotoFlatClick: PropTypes.func,
  onScrollToImpressions: PropTypes.func,
  onScrollToVoucher: PropTypes.func,
  onScrollToVideo: PropTypes.func,
  onScrollToCertificate: PropTypes.func,
  onImagesLoaded: PropTypes.func,
  listType: PropTypes.string,
  onScrollToExtendedSearch: PropTypes.func,
  showMorePhotosBox: PropTypes.bool,
  setFotoFlatRef: PropTypes.func,
  hasVideo: PropTypes.bool,
  hasVideoUrl: PropTypes.bool,
  hasCertificates: PropTypes.bool,
  hasCertificateUrl: PropTypes.bool,
  isMainSearchUsed: PropTypes.bool,
  onScrollToMainSearch: PropTypes.func,
  goBackToMainSearchResults: PropTypes.func,
  eventHasFotoFlat: PropTypes.bool,
};

export default MediaListMasonry;
